import React, { Component } from "react";
import Helmet from "react-helmet";
import About from "../components/About/About";
import config from "../../data/SiteConfig";
import Header from "../components/Header/Header";
import SocialLinks from "../components/SocialLinks/SocialLinks";
import SEO from "../components/SEO/SEO";
import HeaderPage from "../components/Header/HeaderPage";
import Menu from "../components/Menu/Menu";
import Footer from "../components/Footer/Footer";
import ToTopButton from "../components/ToTopButton/ToTopButton";

import picture from "../components/About/img/about.jpg";

class AboutPage extends Component {
  render() {
    const { slug } = this.props.pathContext;
    const postNode = {
        "frontmatter": {
            "title": "Page non trouvée",
            "description":  "Integral Service est une agence Web Lyonnaise spécialisée dans les technologies de l'internet. Notre coeur de métier est de réaliser des applications Web innovantes pour répondre aux besoins métiers de nos clients.",
            "cover": picture
        }
    };

    let title = "Oups !";
    let description = "Page non trouvée";
    let goto = "En savoir plus";

    return (
      <div className="about" id="outer-container">
        <Helmet title={title} />
        <SEO postPath={slug} postNode={postNode} postSEO />
        <Menu/>
            <div id="page-wrap">
              <main id="fh5co-about">
                <Header />
                <HeaderPage title={title} description={description}  picture={picture} />
                <section className="container">
                    <div className="row row-bottom-padded-lg row-top-padded-lg">
                            <div className="col">
                            <h2>La page que vous recherchez n'existe pas/plus</h2>
                            <p>Malheureusement il semble que la page que vous recherchez n'existe plus. Mais on vous propose d'en découvrir plein de super intéressantes:</p>
                            <ul>
                                <li><a href="/" title="Retour à l'accueil du site">Accueil</a></li>
                                <li><a href="/blog" title="Notre super blog">Notre super blog !</a></li>
                                <li><a href="/about" title="Découvrez qui nous sommes !">Qui sommes nous ?</a></li>
                                <li><a href="/services" title="nous découvrir">Découvrez ce qu'on fait</a></li>

                               </ul>
                            </div>  
                    </div>
                </section>
              </main>
              <Footer/>
              <ToTopButton/>
            </div>
      </div>
    );
  }
}

export default AboutPage;



// WEBPACK FOOTER //
// ./src/pages/404.jsx